import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useAuthState } from "../../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { GeneralInformationPostAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/GeneralInformationSlice";
import { DistrictDDL } from "../../../../CommonDDL/DistrictDDL";
import { TalukaNameDDL } from "../../../../CommonDDL/TalukaNameDDL";
import { VillageDDL } from "../../../../CommonDDL/VillageDDL";
import { ClusterNameDDL } from "../../../../CommonDDL/ClusterNameDDL";
import { FieldStationOfficerDDL } from "../../../../CommonDDL/FieldStationOfficerDDL";
import { ImplementingAgencyNameDDL } from "../../../../CommonDDL/ImplementingAgencyNameDDL";
import { TypeofMonitoringNameDDL } from "../../../../CommonDDL/TypeofMonitoringNameDDL";
import { StateNameDDL } from "../../../../CommonDDL/StateNameDDL";
import { RegionalOfficeNameDDL } from "../../../../CommonDDL/RegionalOfficeNameDDL";


export default function AddGeneralInformationPopUp(props) {

    const { handleShowAddModal, handleIsPost, ShowAddModal, IsClear, setIsClear, YearValue, MonthValue } = props
    const { flag, data } = ShowAddModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()


    const [BeneficiaryNameID, setBeneficiaryNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [StateID, setStateID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [RegionalOfficeID, setRegionalOfficeID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [DistrictID, setDistrictID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [TalukaID, setTalukaID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [VillageID, setVillageID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ClusterID, setClusterID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [FieldStationOfficerID, setFieldStationOfficerID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [AgencyID, setAgencyID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [TypeofMonitoringID, setTypeofMonitoringID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleSubmit = () => {
        const data = {

            T_SurveyorGeneralInfoID: flag == 'Update' ? ShowAddModal.data.t_SurveyorGeneralInfoID : 0,
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_StateNameID: StateID.ID,
            M_RegionalOfficeID: RegionalOfficeID.ID,
            M_FieldStationOfficerID: FieldStationOfficerID.ID,
            M_DistrictNameID: DistrictID.ID,
            M_TalukaNameID: TalukaID.ID,
            M_VillageNameID: VillageID.ID,
            M_Village_Wise_ClusterID: ClusterID.ID,
            M_IndicatorMaster_MonitoringID: 0,
            M_AgencyID: AgencyID.ID,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost

        }
        dispatch(GeneralInformationPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.GeneralInformationPostData)


    return (
        <>
            <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "#00000055" }}
            >
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title ml-4" id="exampleModalLongTitle">
                                General Information
                            </h5>
                            <button
                                onClick={() => handleShowAddModal(false, '')}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <StateNameDDL
                                        StateID={StateID}
                                        setStateID={setStateID}
                                        apiFlag='Web_Beneficiary'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        AstricSignFlag="AstricSign"
                                    />

                                </div>
                                <div className="col-12 col-lg-6">
                                    <RegionalOfficeNameDDL
                                        RegionalOfficeID={RegionalOfficeID}
                                        setRegionalOfficeID={setRegionalOfficeID}
                                        apiFlag='Web_Beneficiary'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        StateID={StateID}
                                        AstricSignFlag="AstricSign"
                                    />

                                </div>
                                <div className="col-12 col-lg-6">
                                    <FieldStationOfficerDDL
                                        FieldStationOfficerID={FieldStationOfficerID}
                                        setFieldStationOfficerID={setFieldStationOfficerID}
                                        apiFlag='Web_Beneficiary'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        RegionalOfficeID={RegionalOfficeID}
                                        AstricSignFlag="AstricSign"
                                        ScreenFlag='AdminDashboard'
                                        AgencyID={AgencyID}
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <DistrictDDL
                                        DistrictID={DistrictID}
                                        setDistrictID={setDistrictID}
                                        StateID={StateID}
                                        apiFlag='Web_Beneficiary'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        AstricSignFlag="AstricSign"
                                        DistrictFlag="district"
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <TalukaNameDDL
                                        TalukaID={TalukaID}
                                        setTalukaID={setTalukaID}
                                        apiFlag='All'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        StateID={StateID}
                                        DistrictID={DistrictID}
                                        AstricSignFlag="AstricSign"
                                    />
                                </div>

                                <div className="col-12 col-lg-6">
                                    <VillageDDL
                                        VillageID={VillageID}
                                        setVillageID={setVillageID}
                                        apiFlag='Web_Beneficiary'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        StateID={StateID}
                                        DistrictID={DistrictID}
                                        TalukaID={TalukaID}
                                        AstricSignFlag="AstricSign"
                                    />
                                </div>

                                <div className="col-12 col-lg-6">
                                    <ClusterNameDDL
                                        ClusterID={ClusterID}
                                        setClusterID={setClusterID}
                                        apiFlag='Web_Beneficiary'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        VillageID={VillageID}
                                        AstricSignFlag="AstricSign"
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <ImplementingAgencyNameDDL
                                        AgencyID={AgencyID}
                                        setAgencyID={setAgencyID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        VillageID={VillageID}
                                        AstricSignFlag="AstricSign"
                                    />

                                </div>


                                {/* <div className="col-12 col-lg-6">
                                    
                                    <TypeofMonitoringNameDDL
                                        TypeofMonitoringID={TypeofMonitoringID}
                                        setTypeofMonitoringID={setTypeofMonitoringID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        VillageID={VillageID}
                                        AstricSignFlag="AstricSign"
                                    />


                                </div> */}


                                <div className="col-12">
                                    <div className="form-group float-end mt-3">
                                        <button
                                            disabled={StateID.ID == 0 || RegionalOfficeID.ID == '0' || DistrictID.ID == "0" || TalukaID.ID == "0" || VillageID.ID == '0' || ClusterID.ID == '0' ||
                                                AgencyID.ID == '0' || FieldStationOfficerID.ID == '0'}
                                            type="button"

                                            className="btn btn-outline-dark border-2 mx-2"
                                            data-ktwizard-type="action-next"
                                            onClick={handleSubmit}
                                        >
                                            Update
                                        </button>
                                        <button
                                            type="button"

                                            className="btn btn-danger border-2"
                                            data-ktwizard-type="action-next"
                                            onClick={() => handleShowAddModal(false, '')}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
